<template>
  <!-- Modale per la visualizzazione e la scelta del premio del dipendente -->
  <b-modal
    v-model="open_close_modal"
    title="Conversione del premio di risultato"
    size="lg"
    modal-class="cp-modale-premio"
    @show="carica_dati_premio"
  >
    <!-- Caricamento dei dati della campagna e del premio -->
    <div v-if="caricamento_in_corso" class="text-center py-4">
      <b-spinner variant="primary" />
      <p class="mt-2 mb-0">Caricamento premio...</p>
    </div>
    <!-- Dati del premio assegnato e confronto delle alternative -->
    <div v-else-if="dati_premio">
      <!-- Informazioni della campagna e del premio assegnato -->
      <div class="cp-info-campagna mb-4">
        <b-row>
          <!-- Informazioni della campagna -->
          <b-col cols="12" md="6">
            <div class="cp-info-riga">
              <span class="cp-info-etichetta">Campagna:</span>
              <strong>{{ dati_premio.descrizione }}</strong>
            </div>
            <div class="cp-info-riga">
              <span class="cp-info-etichetta">Scadenza risposta:</span>
              <strong>{{ dati_premio.data_scadenza_risposta }}</strong>
            </div>
          </b-col>
          <!-- Premio assegnato -->
          <b-col cols="12" md="6" class="cp-info-premio">
            <div class="cp-riepilogo-contenuto">
              <font-awesome-icon
                icon="coins"
                class="cp-riepilogo-icona"
              />
              <div>
                <div class="cp-info-riga">
                  <strong>Premio assegnato (importo lordo):</strong>
                </div>
                <div class="cp-info-riga">
                  <strong>{{ formatta_importo(dati_premio.valore) }}</strong>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <!-- Confronto economico -->
      <b-row class="cp-riga-compatta">
        <b-col cols="12" md="6" class="mb-0">
          <div
            class="cp-scheda cp-scheda-welfare"
            :class="{ 'cp-scheda-selezionata': scelta_registrata === 'WELFARE' }"
          >
            <h4 class="cp-titolo-scheda">
              <span class="cp-icona cp-icona-welfare">
                <font-awesome-icon icon="gift"/>
              </span>
              Welfare
            </h4>
            <p>
              Ricevi l'importo in crediti welfare da utilizzare
              sulla piattaforma esenti da tasse e contributi.
            </p>
            <!-- Maggiorazione Welfare -->
            <div class="cp-dettaglio-percentuale">
              <b-icon
                icon="bar-chart-fill"
                class="cp-dettaglio-icona"
              />
              <span>
                Maggiorazione welfare:
                <strong>{{ dati_premio.percentuale_maggiorazione }}%</strong>
              </span>
            </div>
            <div class="cp-importo">
              {{ formatta_importo(importo_welfare) }}
            </div>
            <div class="cp-nota-importo">
              Importo Welfare*
            </div>
            <!-- Pulsante di scelta Welfare -->
            <b-button
              v-show="puo_effettuare_scelta"
              :disabled="scelta_registrata === 'WELFARE'"
              variant="success"
              block
              class="cp-btn-welfare"
              @click="scelta_selezionata = 'WELFARE'; conferma_scelta_premio()"
            >
              Converti premio in welfare
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" md="6" class="mb-0">
          <div
            class="cp-scheda cp-scheda-busta"
            :class="{ 'cp-scheda-selezionata': scelta_registrata === 'BUSTA_PAGA' }"
          >
            <h4 class="cp-titolo-scheda">
              <span class="cp-icona cp-icona-busta">
                <font-awesome-icon icon="university"/>
              </span>
              Busta paga
            </h4>
            <p>
              Ricevi l'importo in busta paga, con l'applicazione
              delle trattenute fiscali e previdenziali previste
              dalla normativa.
            </p>
            <!-- Tasse e contributi -->
            <div class="cp-dettaglio-percentuale">
              <b-icon
                icon="bar-chart-fill"
                class="cp-dettaglio-icona cp-icona-decrescente"
              />
              <span>
                Tasse e contributi:
                <strong>10,19%</strong>
              </span>
            </div>
            <div class="cp-importo">
              {{ formatta_importo(importo_busta_paga) }}
            </div>
            <div class="cp-nota-importo">
              Importo netto stimato**
            </div>
            <!-- Pulsante di scelta Busta paga -->
            <b-button
              v-show="puo_effettuare_scelta"
              :disabled="scelta_registrata === 'BUSTA_PAGA'"
              variant="warning"
              block
              class="cp-btn-busta"
              @click="scelta_selezionata = 'BUSTA_PAGA'; conferma_scelta_premio()"
            >
              Ricevi premio in busta paga
            </b-button>
          </div>
        </b-col>
      </b-row>
      <!-- Messaggio informativo quando la campagna è chiusa -->
      <b-alert
        v-if="campagna && campagna.stato === 'CHIUSO'"
        show
        variant="info"
        class="mt-3 mb-0"
      >
        <!-- Campagna chiusa con scelta già registrata -->
        <template v-if="scelta_registrata">
          La scelta registrata è disponibile in sola consultazione e non può essere modificata perché la campagna è chiusa.
        </template>
        <!-- Campagna chiusa senza scelta registrata -->
        <template v-else>
          Non è più possibile effettuare la scelta perché la campagna è chiusa.
        </template>
      </b-alert>
      <!-- Messaggio di sola consultazione quando è scaduto il termine per modificare la scelta -->
      <b-alert
        v-else-if="!puo_effettuare_scelta && scelta_registrata"
        show
        variant="info"
        class="mt-3 mb-0"
      >
        La scelta registrata è disponibile in sola consultazione e non può più essere modificata perché il termine per la risposta è scaduto.
      </b-alert>
    </div>
    <!-- Messaggio in caso di errore -->
    <b-alert v-else show variant="danger">
      Impossibile recuperare i dati del premio.
    </b-alert>
    <!-- Note esplicative dei calcoli -->
    <template #modal-footer>
      <div class="cp-note-calcolo text-left w-100">
        <div>
          * L'importo Welfare comprende la maggiorazione prevista
          dal contratto integrativo aziendale.
        </div>
        <div>
          ** L'importo in busta paga è una stima calcolata applicando
          l'1% di imposta sostitutiva e il 9,19% di contributi INPS. Ogni caso specifico deve essere valutato singolarmente consultando l'ufficio HR.
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";
import { apiUrl } from "@/apiUrl";

export default {
  name: "CPDipendenteSceltaModal",

  model: {
    prop: "show_modal",
    event: "close"
  },

  props: {
    show_modal: { type: Boolean, default: false },
    campagna: { type: Object, default: null }
  },

  data() {
    return {
      // Dati della campagna e del premio restituiti dal backend.
      dati_premio: null,

      // Indica se è in corso il recupero dei dati.
      caricamento_in_corso: false,

      // Scelta selezionata dal dipendente prima della conferma.
      // Valori possibili: WELFARE, BUSTA_PAGA oppure null.
      scelta_selezionata: null
    };
  },

  computed: {
    // Gestisce l'apertura e la chiusura della modale tramite il componente padre.
    open_close_modal: {
      get() {
        return this.show_modal;
      },
      set(value) {
        this.$emit("close", value);
      }
    },

    // Restituisce la scelta già registrata dal dipendente.
    // Se non esiste ancora una scelta, restituisce null.
    scelta_registrata() {

      if (!this.dati_premio || !this.dati_premio.scelta) {
        return null;
      }

      return this.dati_premio.scelta.risposta;
    },

    // Verifica se il dipendente può effettuare o modificare la scelta.
    // La prima scelta è consentita anche dopo la scadenza, purché la campagna sia ancora pubblicata.
    puo_effettuare_scelta() {

      if (!this.campagna || !this.dati_premio) {
        return false;
      }

      // Una campagna chiusa è disponibile soltanto in consultazione.
      if (this.campagna.stato !== "PUBBLICATO") {
        return false;
      }

      // Se non esiste una scelta registrata, è consentita la prima risposta.
      if (!this.scelta_registrata) {
        return true;
      }

      // Una scelta già registrata può essere modificata soltanto entro la data di scadenza della risposta.
      const oggi = new Date();
      const data_scadenza = new Date(
        this.dati_premio.data_scadenza_risposta + "T23:59:59"
      );

      return oggi <= data_scadenza;
    },

    // Calcola il valore del premio convertito in Welfare, applicando la maggiorazione prevista per il dipendente.
    importo_welfare() {
      if (!this.dati_premio) {
        return null;
      }

      const valore = Number(this.dati_premio.valore);
      const percentuale = Number(this.dati_premio.percentuale_maggiorazione);

      return Math.round((valore + (valore * percentuale / 100) + Number.EPSILON) * 100) / 100;
    },

    // Stima l'importo netto in busta paga applicando l'1% di imposta sostitutiva e il 9,19% di contributi INPS.
    importo_busta_paga() {
      if (!this.dati_premio) {
        return null;
      }

      const valore = Number(this.dati_premio.valore);

      const imposta = valore * 1 / 100;
      const contributi_inps = valore * 9.19 / 100;

      return Math.round((valore - imposta - contributi_inps + Number.EPSILON) * 100) / 100;
    }

  },

  methods: {
    // Chiede conferma al dipendente prima di registrare la scelta del premio.
    async conferma_scelta_premio() {

      if (!this.scelta_selezionata) {
        return;
      }

      const messaggio = this.scelta_selezionata === "WELFARE"
        ? "Confermi di voler convertire il premio di risultato in Welfare?"
        : "Confermi di voler ricevere il premio di risultato in busta paga?";

      const confermato = await this.$bvModal.msgBoxConfirm(
        messaggio,
        {
          title: "Conferma scelta",
          okTitle: "Conferma",
          cancelTitle: "Annulla",
          okVariant: "primary",
          cancelVariant: "secondary",
          centered: true
        }
      );

      if (!confermato) {
        this.scelta_selezionata = null;
        return;
      }

      // Registra la scelta solo dopo la conferma del dipendente.
      await this.salva_scelta_premio();
    },
    
    // Registra la scelta confermata dal dipendente.
    async salva_scelta_premio() {

      if (!this.campagna || !this.scelta_selezionata) {
        return;
      }

      try {

       await axios.post(
          `${apiUrl.conversionepremioapi.campagne}${this.campagna.id}/scelta/`,
          {
            risposta: this.scelta_selezionata
          }
        );

        // Aggiorna i dati del premio con la scelta registrata.
        await this.carica_dati_premio();

        // Comunica al componente padre che la scelta è stata salvata.
        this.$emit("scelta-salvata");

        // Mostra un messaggio di conferma del salvataggio.
        this.$bvToast.toast(
          "La tua scelta è stata registrata correttamente.",
          {
            title: "Conversione Premio",
            variant: "success",
            solid: true
          }
        );

        // Chiude la modale dopo il salvataggio.
        this.open_close_modal = false;

        this.scelta_selezionata = null;

      } catch (error) {

        console.error(
          "Errore salvataggio scelta Conversione Premio:",
          error
        );

        this.$bvToast.toast(
          "Impossibile salvare la scelta. Riprova.",
          {
            title: "Errore",
            variant: "danger",
            solid: true
          }
        );
      }
    },

    // Recupera i dati del premio assegnato al dipendente.
    async carica_dati_premio() {

      this.dati_premio = null;

      if (!this.campagna) {
        return;
      }

      this.caricamento_in_corso = true;

      try {
        const response = await axios.get(
          `${apiUrl.conversionepremioapi.campagne}${this.campagna.id}/scelta/`
        );

        this.dati_premio = response.data;

      } catch (error) {
        console.error(
          "Errore recupero premio Conversione Premio:",
          error
        );

      } finally {
        this.caricamento_in_corso = false;
      }
    },

    // Formatta gli importi monetari in euro.
    formatta_importo(valore) {
      return Number(valore).toLocaleString("it-IT", {
        style: "currency",
        currency: "EUR"
      });
    }
  }
};
</script>
<style scoped>
/* Card grigio chiaro con le informazioni della campagna. */
.cp-info-campagna {
  background-color: #edf2f6;
  border-radius: 8px;
  padding: 4px 16px;
}

/* Allinea etichette e valori sulla stessa riga. */
.cp-info-riga {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 4px;
  color: #212529;
}

/* Larghezza uniforme delle etichette. */
.cp-info-etichetta {
  flex: 0 0 145px;
}

/* Evidenzia i valori della campagna. */
.cp-info-riga strong {
  color: #0b1b4b;
}

/* Allinea icona e informazioni del premio. */
.cp-riepilogo-contenuto {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
}

/* Icone del premio e della maggiorazione. */
.cp-riepilogo-icona {
  font-size: 36px;
  color: #2684d6;
  flex-shrink: 0;
}

/* Colore dell'icona del premio nel riquadro grigio. */
.cp-info-premio .cp-riepilogo-icona {
  color: #343a40;
}

/* Separatore tra informazioni della campagna e premio assegnato. */
@media (min-width: 768px) {
  .cp-info-premio {
    border-left: 2px solid #c5cbd1;
    padding-left: 24px;
  }
}

/* Stile comune delle schede di confronto del premio. */
.cp-scheda {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 12px 20px 12px;
  border: 2px solid transparent;
  border-radius: 10px;
}

/* Scheda Welfare: sfondo verde chiaro e testo verde scuro. */
.cp-scheda-welfare {
  background-color: #e8f5e9;
  color: #1b5e20;
}

/* Scheda Busta paga: sfondo arancione chiaro e testo marrone scuro. */
.cp-scheda-busta {
  background-color: #fff0dc;
  color: #6d3900;
}

/* Allinea il titolo della scheda con la relativa icona circolare. */
.cp-titolo-scheda {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 25px;
  font-weight: 600;
  min-height: 54px;
  position: relative;
  top: -8px;
  margin-bottom: -10px;
}
.cp-titolo-scheda .cp-icona {
  position: relative;
  top: 8px;
}

/* Contenitore circolare delle icone. */
.cp-icona {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  color: #ffffff;
  font-size: 30px;
  flex-shrink: 0;
}

/* Icona Welfare: cerchio verde scuro. */
.cp-icona-welfare {
  background-color: #1b5e20;
}

/* Icona Busta paga: cerchio arancione scuro. */
.cp-icona-busta {
  background-color: #c85208;
}

/* Pulsante di scelta Welfare: stesso verde dell'icona Gift. */
.cp-btn-welfare {
  background-color: #1b5e20;
  border-color: #1b5e20;
  border-radius: 8px;
  color: #ffffff;
}

/* Colore del pulsante al passaggio del mouse. */
.cp-btn-welfare:hover,
.cp-btn-welfare:focus {
  background-color: #144a19;
  border-color: #144a19;
  color: #ffffff;
}

/* Pulsante di scelta Busta paga. */
.cp-btn-busta {
  background-color: #c85208;
  border-color: #c85208;
  border-radius: 8px;
  color: #ffffff;
}

/* Colore del pulsante al passaggio del mouse. */
.cp-btn-busta:hover,
.cp-btn-busta:focus {
  background-color: #ad4506;
  border-color: #ad4506;
  color: #ffffff;
}

/* Evidenzia la scheda corrispondente alla scelta registrata dal dipendente. */
.cp-scheda-selezionata {
  border: 3px solid #198754;
  border-radius: 8px;
}

/* Bordo arancione quando è stata scelta Busta paga. */
.cp-scheda-busta.cp-scheda-selezionata {
  border-color: #c85208;
}

/* Testi descrittivi delle due alternative. */
.cp-scheda p {
  color: #212529;
  margin-left: 64px;
  margin-bottom: 12px;
  position: relative;
  top: -8px;
  font-size: 15px;
  line-height: 1.5;
}

/* Dettaglio della maggiorazione o delle trattenute nelle schede. */
.cp-dettaglio-percentuale {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 34px;
  margin-bottom: 12px;
  position: relative;
  top: -8px;
  font-size: 15px;
}

/* Icona del dettaglio percentuale. */
.cp-dettaglio-icona {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Grafico a barre decrescente per tasse e contributi. */
.cp-icona-decrescente {
  transform: scaleX(-1);
}

/* Riquadro evidenziato che contiene l'importo. */
.cp-importo {
  border-radius: 8px;
  padding: 5px 10px;
  position: relative;
  top: -8px;
  margin-top: auto;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
}

/* Importo Welfare: testo verde scuro e sfondo verde più intenso. */
.cp-scheda-welfare .cp-importo {
  background-color: #c8e6c9;
  color: #1b5e20;
}

/* Importo Busta paga: testo arancione scuro e sfondo arancione più intenso. */
.cp-scheda-busta .cp-importo {
  background-color: #ffddb3;
  color: #9a4d00;
}

/* Etichetta sotto l'importo. */
.cp-nota-importo {
  margin-top: 10px;
  text-align: center;
  position: relative;
  top: -8px;
  font-size: 14px;
  font-weight: 500;
  min-height: 22px;
  color: #212529;
}

/* Note esplicative dei calcoli in fondo alla modale. */
.cp-note-calcolo {
  font-size: 13px;
  line-height: 1.4;
  color: #6c757d;
}

/* Pulsante Welfare disabilitato: versione outline. */
.btn.cp-btn-welfare:disabled,
.btn.cp-btn-welfare.disabled {
  background-color: transparent;
  border-color: #1b5e20;
  color: #1b5e20;
  opacity: 0.6;
}

/* Pulsante Busta paga disabilitato: versione outline. */
.btn.cp-btn-busta:disabled,
.btn.cp-btn-busta.disabled {
  background-color: transparent;
  border-color: #c85208;
  color: #c85208;
  opacity: 0.6;
}

</style>
<style>

/* Spazio tra le schede di confronto e il footer della modale. */
.cp-modale-premio .modal-body {
  padding-bottom: 24px;
}

/* Riduce lo spazio tra i pulsanti e le note finali. */
.cp-modale-premio .modal-footer {
  padding-top: 4px;
}

/* Riduce soltanto lo spazio centrale tra le schede di confronto. */
@media (min-width: 768px) {
  .cp-riga-compatta > [class*="col-"]:first-child {
    padding-right: 8px;
  }

  .cp-riga-compatta > [class*="col-"]:last-child {
    padding-left: 8px;
  }
}

</style>